import { render } from "./StaffAccessManagement.vue?vue&type=template&id=282b45c8"
import script from "./StaffAccessManagement.vue?vue&type=script&lang=js"
export * from "./StaffAccessManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__